import { Skeleton, Spin } from 'antd';

const Loading: React.FC = () => (
    <div className='h-[300px] flex justify-center pt-52'>
        <Spin spinning size='large' />
    </div>
);

export default Loading;
